import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AnimationItem } from "lottie-web/build/player/lottie_light";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SeoService } from "src/app/services/seo/seo.service";
import projects from "src/assets/projects";
import { PATHS, ROUTES } from "src/constants";
import { IProject } from "src/assets/projects";

@Component({
  selector: "app-home-de",
  templateUrl: "./home-de.component.html",
  styleUrls: ["./home-de.component.scss"],
})
export class HomeDeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  public ROUTES = ROUTES;
  public PATHS = PATHS;
  public form: FormGroup;
  public leadSent = false;
  public projectsToShow: IProject[];

  public labyrinthAnimation = {
    path: "/assets/animations/labyrinth.json",
    autoplay: true,
    loop: true,
  };

  public mouseAnimation = {
    path: "/assets/animations/mouse.json",
    autoplay: true,
    loop: true,
  };

  public infiniteCirclesAnimation = {
    path: "/assets/animations/infinite-circles.json",
    autoplay: true,
    loop: true,
  };

  constructor(private fb: FormBuilder, private seo: SeoService, @Inject("isBrowser") private isBrowser: boolean) {
    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  ngOnInit() {
    this.seo.updateMeta({
      title: "coara - Digitale Produktentwicklung",
      description:
        "Coara ist ein Partner für SaaS-Produktentwicklung und Plattformbetrieb. Wir sind Inkubator für Ihre Ideen, Accelerator für Ihr Geschäft und Profitabilitätstreiber.",
      imageUrl: "https://coara.co/assets/images/sharing/facebook.jpg",
    });
    this.seo.setCanonicalURL();
    this.projectsToShow = [...projects];
    this.projectsToShow.sort((a, _b) => a.uri.length - Math.floor(Math.random() * this.projectsToShow.length)).splice(0, 5);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public animationCreated(animationItem: AnimationItem): void {
    // not implemented, but required as a lottie callback function
  }

  public sendLead() {
    if (this.form.valid) {
      this.leadSent = true;
    }
  }
}
